<template>
  <info-header-card
    v-if="project"
    :icon="project.icon()"
    :header="card_header"
    :rows="card_rows"
  ></info-header-card>
</template>

<script>
import InfoHeaderCard from "@/components/shared/InfoHeaderCard";
import moment from "moment"

export default {
  name: "ProjectCard",
  components: {
    InfoHeaderCard
  },
  props: {
    project: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      card_rows: [],
      card_header: null
    };
  },
  methods: {
    /**
     * Format card component data
     */
    setComponentData() {
      if (!this.project.id) {
        this.card_header = "";
      } else {
        // set object data
        this.card_header = this.formatHeader();
        this.card_rows = this.formatBodyRows();
      }
    },

    /**
     * Format card body label / value row content
     * @returns {*[]}
     */
    formatBodyRows() {
      return [
        {
          label: "Status",
          value: this.project.getProjectStatusLogs()
            ? this.project
                .getProjectStatusLogs()
                .first()
                .getProjectStatus().status
            : null
        },
        {
          label: "Submissions",
          value: this.project.getSubmissions()
            ? this.project.getSubmissions().models.length
            : 0
        },
        {
          label: "Created On",
          value: moment(this.project.created_at).format("YYYY-MM-DD")
        }
      ];
    },
    /**
     * Format card header
     * @returns
     */
    formatHeader() {
      if (this.project) {
        let types = [];
        this.project.getSubmissions().each(submssion => {
          types.push(submssion.getSampleType().name);
        });
        return [
          this.project.publicNumber(),
          this.project.getCustomer().name,
          types.join(" | ")
        ].join(" | ");
      }
      return null;
    }
  },
  mounted() {
    if (this.project) {
      this.setComponentData();
    }
  }
};
</script>
